import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
const SecondaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const borderProps = {
        borderRadius: "radius.16",
    };
    return (_jsx(Box, Object.assign({}, borderProps, { backgroundColor: "color.background.light", padding: "spacing.16", marginTop: marginTop, children: children })));
};
const TertiaryPriceComponentWrapper = ({ children, marginTop, }) => {
    return _jsx(Box, { marginTop: marginTop, children: children });
};
export const ComponentWrapper = ({ type, children, marginTop, isLast = false, }) => {
    if (type === "TERTIARY") {
        return (_jsx(TertiaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
    }
    return (_jsx(SecondaryPriceComponentWrapper, { marginTop: marginTop, isLast: isLast, children: children }));
};
